<template>
  <router-view />
</template>

<style>
@import 'vue-select/dist/vue-select.css';
</style>